import {
	PIGGY_BANK_MAX_PROGRESS,
	PIGGY_BANK_QUEST_ID,
} from "@/config/constants";
import {
	FrameName,
	tilerepoAllFishingBoatsFrameNames,
	tileRepoArenaFrameNames,
	tileRepoArmoryFrameNames,
	tileRepoBakeryFrameNames,
	tilerepoBiggerWarehouseFrameNames,
	tileRepoBlacksmithFrameNames,
	tilerepoBuildingsFrameNames,
	tilerepoClayPitsFrameNames,
	tilerepoCobbledEntityFrameNames,
	tilerepoFishTrapsFrameNames,
	tilerepoForestFrameNames,
	tilerepoGoldMinesFrameNames,
	tilerepoGravelEntityFrameNames,
	tileRepoGuardTowerFrameNames,
	tileRepoHealersHutFrameNames,
	tilerepoIronMinesFrameNames,
	tilerepoLumberMillsFrameNames,
	tileRepoMarketplaceFrameNames,
	tileRepoMediumHousesFrameNames,
	tilerepoMillsFrameNames,
	tilerepoRoadsFrameNames,
	tileRepoScoutTowerFrameNames,
	tilerepoShipyardFrameNames,
	tilerepoStoneQuarriesFrameNames,
	tileRepoUniversityFrameNames,
	tilerepoWaterFrameNames,
	tileRepoWheatFarmsFrameNames,
} from "@/game/entities/config";
import { QuestObjectiveActions } from "@/game/entities/config/quests/quest_objective_actions.ts";
import { QuestRewardTypes } from "@/game/entities/config/quests/quest_reward_types.ts";
import { QuestTypes } from "@/game/entities/config/quests/quest_types.ts";
import { ResourceType } from "@/game/entities/config/resources";
import useResourcesStore from "@/store/useResourcesStore";
import {
	EXPLORATION_SPEED_CONST,
	LevelAxis,
	type QuestItem,
} from "@/types/quest.ts";

export const MAIN_DAILY_QUEST_ID = 9001;

export const quests = new Map<number, QuestItem>([
	[
		1,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1001",
			flavor: "quest.flavor_1001",
			assignment: "task.explore_tiles",
			objective: {
				action: QuestObjectiveActions.CLEAR_TILES,
				amount: 20,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 2000,
					},
				],
			},
		},
	],
	[
		2,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1002",
			flavor: "quest.flavor_1002",
			hintText: "quest.hint_1002",
			assignment: "task.build_2to4_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: FrameName.GATHERERS_HUT,
				amount: 4,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 4000,
					},
				],
			},
		},
	],
	[
		3,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1003",
			flavor: "quest.flavor_1003",
			hintText: "quest.hint_1003",
			assignment: "task.have_forests",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tilerepoForestFrameNames,
				amount: 20,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 100,
					},
				],
			},
		},
	],
	[
		4,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1004",
			flavor: "quest.flavor_1004",
			hintText: "quest.hint_1004",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 4,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 30,
					},
				],
			},
		},
	],
	[
		5,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1005",
			flavor: "quest.flavor_1005",
			hintText: "quest.hint_1005",
			assignment: "task.have_2to4_lumber_mills",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tilerepoLumberMillsFrameNames,
				amount: 2,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 15000,
					},
				],
			},
		},
	],
	[
		6,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1006",
			flavor: "quest.flavor_1006",
			assignment: "task.explore_tiles",
			objective: {
				action: QuestObjectiveActions.CLEAR_TILES,
				amount: 40,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 1,
					},
				],
			},
		},
	],
	[
		7,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1007",
			flavor: "quest.flavor_1007",
			hintText: "quest.hint_1007",
			assignment: "task.pay",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.LUMBER,
				amount: 2500,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 20000,
					},
				],
			},
		},
	],
	[
		8,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1008",
			flavor: "quest.flavor_1008",
			assignment: "task.build_2to4_small_houses",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: FrameName.SMALL_HOUSES,
				amount: 4,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 25000,
					},
				],
			},
		},
	],
	[
		9,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1009",
			flavor: "quest.flavor_1009",
			hintText: "quest.hint_1004",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 7,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 30000,
					},
				],
			},
		},
	],
	[
		10,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1010",
			flavor: "quest.flavor_1010",
			hintText: "quest.hint_1010",
			assignment: "task.have_2to4_wheat_farms",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoWheatFarmsFrameNames,
				amount: 3,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 150,
					},
				],
			},
		},
	],
	[
		11,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1011",
			flavor: "quest.flavor_1011",
			assignment: "task.explore_tiles",
			objective: {
				action: QuestObjectiveActions.CLEAR_TILES,
				amount: 80,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 2,
					},
				],
			},
		},
	],
	[
		12,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1012",
			flavor: "quest.flavor_1012",
			assignment: "task.pay",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.COINS,
				amount: 50000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 200,
					},
				],
			},
		},
	],
	[
		13,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1013",
			flavor: "quest.flavor_1013",
			assignment: "task.have_gold_mines",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tilerepoGoldMinesFrameNames,
				amount: 6,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 40000,
					},
				],
			},
		},
	],
	[
		14,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1014",
			flavor: "quest.flavor_1014",
			hintText: "quest.hint_1014",
			assignment: "task.explore_location",
			objective: {
				action: QuestObjectiveActions.DISCOVER_SPECIFIC_TILE,
				coordination: { x: 523, y: 566 },
				amount: 1,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 50000,
					},
				],
			},
			badgeCoordinates: { x: 523, y: 566 },
		},
	],
	[
		15,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1015",
			flavor: "quest.flavor_1015",
			hintText: "quest.hint_1015",
			assignment: "task.have_gravel_roads",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tilerepoGravelEntityFrameNames,
				amount: 50,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 60000,
					},
				],
			},
		},
	],
	[
		16,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1016",
			flavor: "quest.flavor_1016",
			assignment: "task.plant_dense_forests",
			objective: {
				action: QuestObjectiveActions.CHANGE_TERRAIN,
				type: FrameName.DENSE_FOREST,
				amount: 60,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 75000,
					},
				],
			},
		},
	],
	[
		17,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1017",
			flavor: "quest.flavor_1017",
			assignment: "task.explore_tiles",
			objective: {
				action: QuestObjectiveActions.CLEAR_TILES,
				amount: 150,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 3,
					},
				],
			},
		},
	],
	[
		18,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1018",
			flavor: "quest.flavor_1018",
			hintText: "quest.hint_1014",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 2,
				amount: 12,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 100000,
					},
				],
			},
			badgeCoordinates: { x: 523, y: 566 },
		},
	],
	[
		19,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1019",
			flavor: "quest.flavor_1019",
			hintText: "quest.hint_1019",
			assignment: "task.build_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: tilerepoStoneQuarriesFrameNames,
				amount: 10,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 125000,
					},
				],
			},
		},
	],
	[
		20,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1020",
			flavor: "quest.flavor_1020",
			hintText: "quest.hint_1020",
			assignment: "task.pay",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.COINS,
				amount: 500000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 250,
					},
				],
			},
		},
	],
	[
		21,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1021",
			flavor: "quest.flavor_1021",
			assignment: "task.pay",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.STONE,
				amount: 20000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 150000,
					},
				],
			},
		},
	],
	[
		22,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1022",
			flavor: "quest.flavor_1022",
			assignment: "task.explore_tiles",
			objective: {
				action: QuestObjectiveActions.CLEAR_TILES,
				amount: 200,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 4,
					},
				],
			},
		},
	],
	[
		23,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1023",
			flavor: "quest.flavor_1023",
			hintText: "quest.hint_1023",
			assignment: "task.have_bakeries",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoBakeryFrameNames,
				amount: 6,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 175000,
					},
				],
			},
		},
	],
	[
		24,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1024",
			flavor: "quest.flavor_1024",
			assignment: "task.control_towns_of_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SETTLEMENTS_ON_LEVEL,
				amount: 8,
				level: 12,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 200000,
					},
				],
			},
		},
	],
	[
		25,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1025",
			flavor: "quest.flavor_1025",
			assignment: "task.explore_tiles",
			objective: {
				action: QuestObjectiveActions.CLEAR_TILES,
				amount: 250,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 5,
					},
				],
			},
		},
	],
	[
		26,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1026",
			flavor: "quest.flavor_1026",
			hintText: "quest.hint_1026",
			assignment: "task.build_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: tilerepoShipyardFrameNames,
				amount: 6,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 300,
					},
				],
			},
		},
	],
	[
		27,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1027",
			flavor: "quest.flavor_1027",
			assignment: "task.have_food_production",
			objective: {
				action: QuestObjectiveActions.HAVE_RESOURCE,
				type: ResourceType.FOOD_INCOME,
				amount: 3500,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 225000,
					},
				],
			},
		},
	],
	[
		28,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1028",
			flavor: "quest.flavor_1028",
			hintText: "quest.hint_1028",
			assignment: "task.build_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: tilerepoClayPitsFrameNames,
				amount: 8,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 250000,
					},
				],
			},
		},
	],
	[
		29,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1029",
			flavor: "quest.flavor_1029",
			hintText: "quest.hint_1029",
			assignment: "task.pay",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.CLAY,
				amount: 20000,
				pay: 0,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 275000,
					},
				],
			},
		},
	],
	[
		30,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1030",
			flavor: "quest.flavor_1030",
			assignment: "task.explore_tiles",
			objective: {
				action: QuestObjectiveActions.CLEAR_TILES,
				amount: 300,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 6,
					},
				],
			},
		},
	],
	[
		31,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1031",
			flavor: "quest.flavor_1031",
			assignment: "task.control_towns_of_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SETTLEMENTS_ON_LEVEL,
				amount: 12,
				level: 14,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 300000,
					},
				],
			},
		},
	],
	[
		32,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1032",
			flavor: "quest.flavor_1032",
			assignment: "task.have_food_production",
			objective: {
				action: QuestObjectiveActions.HAVE_RESOURCE,
				type: ResourceType.FOOD_INCOME,
				amount: 5000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 350,
					},
				],
			},
		},
	],
	[
		33,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1033",
			flavor: "quest.flavor_1033",
			assignment: "task.have_total_workforce",
			objective: {
				action: QuestObjectiveActions.HAVE_RESOURCE,
				type: ResourceType.POPULATION_INCOME,
				amount: 11000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 350000,
					},
				],
			},
		},
	],
	[
		34,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1034",
			flavor: "quest.flavor_1034",
			hintText: "quest.hint_1034",
			assignment: "task.explore_location",
			objective: {
				action: QuestObjectiveActions.DISCOVER_SPECIFIC_TILE,
				coordination: { x: 583, y: 503 },
				amount: 1,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 400,
					},
				],
			},
			badgeCoordinates: { x: 583, y: 503 },
		},
	],
	[
		35,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1035",
			flavor: "quest.flavor_1035",
			hintText: "quest.hint_1035",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 35,
				amount: 15,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 500000,
					},
				],
			},
			badgeCoordinates: { x: 603, y: 528 },
		},
	],
	[
		36,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1036",
			flavor: "quest.flavor_1036",
			assignment: "task.control_towns_of_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SETTLEMENTS_ON_LEVEL,
				amount: 15,
				level: 16,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 400000,
					},
				],
			},
		},
	],
	[
		37,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1037",
			flavor: "quest.flavor_1037",
			assignment: "task.explore_tiles",
			objective: {
				action: QuestObjectiveActions.CLEAR_TILES,
				amount: 350,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 6,
					},
				],
			},
		},
	],
	[
		38,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1038",
			flavor: "quest.flavor_1038",
			hintText: "quest.hint_1038",
			assignment: "task.build_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: tilerepoIronMinesFrameNames,
				amount: 10,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 50,
					},
				],
			},
		},
	],
	[
		39,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1039",
			flavor: "quest.flavor_1039",
			hintText: "quest.hint_1039",
			assignment: "task.use_super_clickers",
			objective: {
				action: QuestObjectiveActions.USE_SUPER_CLICKER,
				amount: 150,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 500000,
					},
				],
			},
		},
	],
	[
		40,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1040",
			flavor: "quest.flavor_1040",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 22,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 400,
					},
				],
			},
		},
	],
	[
		41,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1041",
			flavor: "quest.flavor_1041",
			assignment: "task.control_towns_south",
			objective: {
				action: QuestObjectiveActions.HAVE_SETTLEMENTS_AXIS,
				amount: 12,
				level: 0,
				axis: LevelAxis.UNDER, // axis y > 512
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 500000,
					},
				],
			},
		},
	],
	[
		42,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1042",
			flavor: "quest.flavor_1042",
			assignment: "task.build_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: tilerepoBiggerWarehouseFrameNames,
				amount: 10,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 550000,
					},
				],
			},
		},
	],
	[
		43,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1043",
			flavor: "quest.flavor_1043",
			hintText: "settlement.hint_13",
			assignment: "task.have_gravel_roads",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tilerepoGravelEntityFrameNames,
				amount: 350,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 50,
					},
				],
			},
		},
	],
	[
		44,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1044",
			flavor: "quest.flavor_1044",
			hintText: "quest.hint_1023",
			assignment: "task.have_blacksmiths",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoBlacksmithFrameNames,
				amount: 7,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 550000,
					},
				],
			},
		},
	],
	[
		45,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1045",
			flavor: "quest.flavor_1045",
			assignment: "task.have_explored_water_tiles",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tilerepoWaterFrameNames,
				amount: 2000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 600000,
					},
				],
			},
		},
	],
	[
		46,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1046",
			flavor: "quest.flavor_1046",
			hintText: "quest.hint_1046",
			assignment: "task.explore_location",
			objective: {
				action: QuestObjectiveActions.DISCOVER_SPECIFIC_TILE,
				coordination: { x: 490, y: 590 },
				amount: 1,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 75,
					},
				],
			},
			badgeCoordinates: { x: 490, y: 590 },
		},
	],
	[
		47,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1047",
			flavor: "quest.flavor_1047",
			hintText: "quest.hint_1039",
			assignment: "task.use_super_clickers",
			objective: {
				action: QuestObjectiveActions.USE_SUPER_CLICKER,
				amount: 250,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 600000,
					},
				],
			},
		},
	],
	[
		48,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1048",
			flavor: "quest.flavor_1048",
			assignment: "task.explore_tiles",
			objective: {
				action: QuestObjectiveActions.CLEAR_TILES,
				amount: 400,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 6,
					},
				],
			},
		},
	],
	[
		49,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1049",
			flavor: "quest.flavor_1049",
			hintText: "quest.hint_1049",
			assignment: "task.have_medium_houses",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoMediumHousesFrameNames,
				amount: 40,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 600000,
					},
				],
			},
		},
	],
	[
		50,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1050",
			flavor: "quest.flavor_1050",
			hintText: "quest.hint_1050",
			assignment: "task.salvage_hut",
			objective: {
				action: QuestObjectiveActions.SALVAGE,
				type: FrameName.ABANDONED_HUT,
				amount: 30,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 650000,
					},
				],
			},
		},
	],
	[
		51,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1051",
			flavor: "quest.flavor_1051",
			hintText: "quest.hint_1051",
			assignment: "task.explore_location",
			objective: {
				action: QuestObjectiveActions.DISCOVER_SPECIFIC_TILE,
				coordination: { x: 441, y: 587 },
				amount: 1,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 650000,
					},
				],
			},
			badgeCoordinates: { x: 441, y: 587 },
		},
	],
	[
		52,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1052",
			flavor: "quest.flavor_1052",
			hintText: "quest.hint_1014",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 2,
				amount: 25,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 400,
					},
				],
			},
			badgeCoordinates: { x: 523, y: 566 },
		},
	],
	[
		53,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1053",
			flavor: "quest.flavor_1053",
			assignment: "task.have_total_workforce",
			objective: {
				action: QuestObjectiveActions.HAVE_RESOURCE,
				type: ResourceType.POPULATION_INCOME,
				amount: 17500,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 700_000,
					},
				],
			},
		},
	],
	[
		54,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1054",
			flavor: "quest.flavor_1054",
			assignment: "task.explore_tiles",
			objective: {
				action: QuestObjectiveActions.CLEAR_TILES,
				amount: 450,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 6,
					},
				],
			},
		},
	],
	[
		55,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1055",
			flavor: "quest.flavor_1055",
			assignment: "task.salvage_house",
			objective: {
				action: QuestObjectiveActions.SALVAGE,
				type: FrameName.BURNED_HOUSE,
				amount: 20,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 800_000,
					},
				],
			},
		},
	],
	[
		56,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1056",
			flavor: "quest.flavor_1056",
			hintText: "quest.hint_1056",
			assignment: "task.build_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: tilerepoMillsFrameNames,
				amount: 5,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 900_000,
					},
				],
			},
		},
	],
	[
		57,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1057",
			flavor: "quest.flavor_1057",
			hintText: "quest.hint_1057",
			assignment: "task.explore_location",
			objective: {
				action: QuestObjectiveActions.DISCOVER_SPECIFIC_TILE,
				coordination: { x: 623, y: 545 },
				amount: 1,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 75,
					},
				],
			},
			badgeCoordinates: { x: 623, y: 545 },
		},
	],
	[
		58,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1058",
			flavor: "quest.flavor_1058",
			hintText: "quest.hint_1023",
			assignment: "task.have_marketplaces",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoMarketplaceFrameNames,
				amount: 15,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 1_000_000,
					},
				],
			},
		},
	],
	[
		59,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1059",
			flavor: "quest.flavor_1059",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 33,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 400,
					},
				],
			},
		},
	],
	[
		60,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1060",
			flavor: "quest.flavor_1060",
			hintText: "quest.hint_1049",
			assignment: "task.have_healers_huts",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoHealersHutFrameNames,
				amount: 5,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 1_200_000,
					},
				],
			},
		},
	],
	[
		61,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1061",
			flavor: "quest.flavor_1061",
			assignment: "task.control_towns_of_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SETTLEMENTS_ON_LEVEL,
				amount: 8,
				level: 30,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.AD_SKIPPER,
						amount: 5,
					},
				],
			},
		},
	],
	[
		62,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1062",
			flavor: "quest.flavor_1062",
			assignment: "task.explore_tiles",
			objective: {
				action: QuestObjectiveActions.CLEAR_TILES,
				amount: 500,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 6,
					},
				],
			},
		},
	],
	[
		63,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1063",
			flavor: "quest.flavor_1063",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 36,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 1_400_000,
					},
				],
			},
		},
	],
	[
		64,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1064",
			flavor: "quest.flavor_1064",
			assignment: "task.pay",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.IRON,
				amount: 100000,
				pay: 0,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 100,
					},
				],
			},
		},
	],
	[
		65,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1065",
			flavor: "quest.flavor_1065",
			assignment: "task.have_explored_water_tiles",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tilerepoWaterFrameNames,
				amount: 6000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 1_600_000,
					},
				],
			},
		},
	],
	[
		66,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1066",
			flavor: "quest.flavor_1066",
			assignment: "task.have_full_towns",
			objective: {
				action: QuestObjectiveActions.HAVE_FULL_SETTLEMENTS,
				amount: 30,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 400,
					},
				],
			},
		},
	],
	[
		67,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1067",
			flavor: "quest.flavor_1067",
			assignment: "task.pay",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.GOODS,
				amount: 75000,
				pay: 0,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 1_800_000,
					},
				],
			},
		},
	],
	[
		68,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1068",
			flavor: "quest.flavor_1068",
			hintText: "quest.hint_1023",
			assignment: "task.have_universities",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoUniversityFrameNames,
				amount: 12,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 2_000_000,
					},
				],
			},
		},
	],
	[
		69,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1069",
			flavor: "quest.flavor_1069",
			hintText: "quest.hint_1023",
			assignment: "task.have_armories",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoArmoryFrameNames,
				amount: 6,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 2_500_000,
					},
				],
			},
		},
	],
	[
		70,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1070",
			flavor: "quest.flavor_1070",
			hintText: "settlement.hint_27",
			assignment: "task.have_cobbled_roads",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tilerepoCobbledEntityFrameNames,
				amount: 200,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 100,
					},
				],
			},
		},
	],
	[
		71,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1071",
			flavor: "quest.flavor_1071",
			hintText: "quest.hint_1071",
			assignment: "task.have_scout_towers",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoScoutTowerFrameNames,
				amount: 6,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 3_000_000,
					},
				],
			},
		},
	],
	[
		72,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1072",
			flavor: "quest.flavor_1072",
			assignment: "task.have_food_production",
			objective: {
				action: QuestObjectiveActions.HAVE_RESOURCE,
				type: ResourceType.FOOD_INCOME,
				amount: 35000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 4_000_000,
					},
				],
			},
		},
	],
	[
		73,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1073",
			flavor: "quest.flavor_1073",
			assignment: "task.collect_coins_from_towns",
			objective: {
				action: QuestObjectiveActions.COLLECT_COINS,
				amount: 50000000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 120,
					},
				],
			},
		},
	],
	[
		74,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1074",
			flavor: "quest.flavor_1074",
			assignment: "task.deploy",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.ARMY,
				amount: 500,
				pay: 0,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 500,
					},
				],
			},
		},
	],
	[
		75,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1075",
			flavor: "quest.flavor_1075",
			assignment: "task.have_total_workforce",
			objective: {
				action: QuestObjectiveActions.HAVE_RESOURCE,
				type: ResourceType.POPULATION_INCOME,
				amount: 70000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 5_000_000,
					},
				],
			},
		},
	],
	[
		76,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1076",
			flavor: "quest.flavor_1076",
			assignment: "task.pay",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.COINS,
				amount: 50000000,
				pay: 0,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 500,
					},
				],
			},
		},
	],
	[
		77,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1077",
			flavor: "quest.flavor_1077",
			hintText: "quest.hint_1049",
			assignment: "task.have_armories",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoArmoryFrameNames,
				amount: 12,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.AD_SKIPPER,
						amount: 5,
					},
				],
			},
		},
	],
	[
		78,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1078",
			flavor: "quest.flavor_1078",
			assignment: "task.control_towns_east",
			objective: {
				action: QuestObjectiveActions.HAVE_SETTLEMENTS_AXIS,
				amount: 35,
				level: 0,
				axis: LevelAxis.RIGHT, // axis x > 512
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 6_000_000,
					},
				],
			},
		},
	],
	[
		79,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1079",
			flavor: "quest.flavor_1079",
			hintText: "quest.hint_1079",
			assignment: "task.build_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: FrameName.OUTPOST,
				amount: 10,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 140,
					},
				],
			},
		},
	],
	[
		80,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1080",
			flavor: "quest.flavor_1080",
			hintText: "quest.hint_1039",
			assignment: "task.use_super_clickers",
			objective: {
				action: QuestObjectiveActions.USE_SUPER_CLICKER,
				amount: 350,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 8_000_000,
					},
				],
			},
		},
	],
	[
		81,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1081",
			flavor: "quest.flavor_1081",
			hintText: "settlement.hint_27",
			assignment: "task.have_cobbled_roads",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tilerepoCobbledEntityFrameNames,
				amount: 500,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 10_000_000,
					},
				],
			},
		},
	],
	[
		82,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1082",
			flavor: "quest.flavor_1082",
			assignment: "task.deploy",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.ARMY,
				amount: 1500,
				pay: 0,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 500,
					},
				],
			},
		},
	],
	[
		83,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1083",
			flavor: "quest.flavor_1083",
			assignment: "task.have_explored_water_tiles",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tilerepoWaterFrameNames,
				amount: 9000,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 7,
					},
				],
			},
		},
	],
	[
		84,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1084.non_translatable",
			flavor: "quest.flavor_1084",
			hintText: "quest.hint_1084",
			assignment: "task.explore_location",
			objective: {
				action: QuestObjectiveActions.DISCOVER_SPECIFIC_TILE,
				coordination: { x: 375, y: 546 },
				amount: 1,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 12_000_000,
					},
				],
			},
			badgeCoordinates: { x: 375, y: 546 },
		},
	],
	[
		85,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1085",
			flavor: "quest.flavor_1085",
			assignment: "task.build_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: FrameName.TANNERY,
				amount: 5,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.AD_SKIPPER,
						amount: 5,
					},
				],
			},
		},
	],
	[
		86,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1086",
			flavor: "quest.flavor_1086",
			assignment: "task.pay",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.STEEL,
				amount: 100000,
				pay: 0,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 500,
					},
				],
			},
		},
	],
	[
		87,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1087",
			flavor: "quest.flavor_1087",
			assignment: "task.pay",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.GOODS,
				amount: 200000,
				pay: 0,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 160,
					},
				],
			},
		},
	],
	[
		88,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1088",
			flavor: "quest.flavor_1088",
			hintText: "quest.hint_1084",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 108,
				amount: 35,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.GEMS,
						amount: 200,
					},
				],
			},
			badgeCoordinates: { x: 375, y: 546 },
		},
	],
	[
		89,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1089",
			flavor: "quest.flavor_1089",
			assignment: "task.have_food_production",
			objective: {
				action: QuestObjectiveActions.HAVE_RESOURCE,
				type: ResourceType.FOOD_INCOME,
				amount: 50000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 500,
					},
				],
			},
		},
	],
	[
		90,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1090",
			flavor: "quest.flavor_1090",
			assignment: "task.collect_coins_from_towns",
			objective: {
				action: QuestObjectiveActions.COLLECT_COINS,
				amount: 100000000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 180,
					},
				],
			},
		},
	],
	[
		91,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1091",
			flavor: "quest.flavor_1091",
			hintText: "quest.hint_1039",
			assignment: "task.use_super_clickers",
			objective: {
				action: QuestObjectiveActions.USE_SUPER_CLICKER,
				amount: 500,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 15_000_000,
					},
				],
			},
		},
	],
	[
		92,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1092",
			flavor: "quest.flavor_1092",
			hintText: "quest.hint_1092",
			assignment: "task.explore_location",
			objective: {
				action: QuestObjectiveActions.DISCOVER_SPECIFIC_TILE,
				coordination: { x: 360, y: 528 },
				amount: 1,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 8,
					},
				],
			},
			badgeCoordinates: { x: 360, y: 528 },
		},
	],
	[
		93,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1093",
			flavor: "quest.flavor_1093",
			hintText: "quest.hint_1093",
			assignment: "task.use_click_multipliers",
			objective: {
				action: QuestObjectiveActions.USE_CLICK_MULTIPLIER,
				amount: 500,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 20_000_000,
					},
				],
			},
		},
	],
	[
		94,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1094",
			flavor: "quest.flavor_1094",
			hintText: "quest.hint_1084",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 108,
				amount: 45,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 500,
					},
				],
			},
			badgeCoordinates: { x: 375, y: 546 },
		},
	],
	[
		95,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1095",
			flavor: "quest.flavor_1095",
			assignment: "task.have_coin_income",
			objective: {
				action: QuestObjectiveActions.HAVE_RESOURCE,
				type: ResourceType.COINS_INCOME,
				amount: 200000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 25_000_000,
					},
				],
			},
		},
	],
	[
		96,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1096",
			flavor: "quest.flavor_1096",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 50,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.AD_SKIPPER,
						amount: 5,
					},
				],
			},
		},
	],
	[
		97,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1097",
			flavor: "quest.flavor_1097",
			assignment: "task.build_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: FrameName.OUTPOST,
				amount: 15,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 9,
					},
				],
			},
		},
	],
	[
		98,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1098",
			flavor: "quest.flavor_1098",
			hintText: "quest.hint_1049",
			assignment: "task.have_guard_towers",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoGuardTowerFrameNames,
				amount: 10,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 200,
					},
				],
			},
		},
	],
	[
		99,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1099",
			flavor: "quest.flavor_1099",
			assignment: "task.control_towns_of_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SETTLEMENTS_ON_LEVEL,
				amount: 40,
				level: 35,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 30_000_000,
					},
				],
			},
		},
	],
	[
		100,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1100",
			flavor: "quest.flavor_1100",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 52,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 500,
					},
				],
			},
		},
	],
	[
		101,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1101",
			flavor: "quest.flavor_1101",
			hintText: "quest.hint_1049",
			assignment: "task.have_arenas",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoArenaFrameNames,
				amount: 8,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.AD_SKIPPER,
						amount: 5,
					},
				],
			},
		},
	],
	[
		102,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1102",
			flavor: "quest.flavor_1102",
			assignment: "task.have_fish_food_income",
			objective: {
				action: QuestObjectiveActions.HAVE_RESOURCE,
				type: ResourceType.FISH_INCOME,
				amount: 9000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 35_000_000,
					},
				],
			},
		},
	],
	[
		103,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1103",
			flavor: "quest.flavor_1103",
			assignment: "task.deploy",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.ARMY,
				amount: 10000,
				pay: 0,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 200,
					},
				],
			},
		},
	],
	[
		104,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1104",
			flavor: "quest.flavor_1104",
			assignment: "task.collect_coins_from_towns",
			objective: {
				action: QuestObjectiveActions.COLLECT_COINS,
				amount: 200000,
			},
			reward: {
				type: QuestRewardTypes.EXPLORATION_SPEED,
				content: [
					{
						reward_resource: EXPLORATION_SPEED_CONST,
						amount: 10,
					},
				],
			},
		},
	],
	[
		105,
		{
			type: QuestTypes.MAIN,
			title: "quest.name_1105",
			flavor: "quest.flavor_1105",
			hintText: "quest.hint_1093",
			assignment: "task.use_click_multipliers",
			objective: {
				action: QuestObjectiveActions.USE_CLICK_MULTIPLIER,
				amount: 1500,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.GEMS,
						amount: 300,
					},
				],
			},
		},
	],

	//##################### SIDE QUESTS #####################
	// Questline: Rupert's Search
	[
		5001,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5001",
			flavor: "",
			assignment: "task.increase_lumber_income",
			objective: {
				action: QuestObjectiveActions.INCREASE_RESOURCE_INCOME,
				type: ResourceType.LUMBER_UNCAPPED_INCOME,
				amount: 500,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 100_000,
					},
				],
			},
		},
	],
	[
		5002,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5002",
			flavor: "",
			assignment: "task.have_forests",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tilerepoForestFrameNames,
				amount: 500,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 35,
					},
				],
			},
		},
	],
	[
		5003,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5003",
			flavor: "",
			assignment: "task.have_old_forests",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: new Set([FrameName.OLD_FOREST]),
				amount: 60,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 250_000,
					},
				],
			},
		},
	],
	[
		5004,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5004",
			flavor: "",
			assignment: "task.have_lumber_mills",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tilerepoLumberMillsFrameNames,
				amount: 15,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 50,
					},
				],
			},
		},
	],
	[
		5005,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5005",
			flavor: "",
			assignment: "task.explore_location",
			objective: {
				action: QuestObjectiveActions.DISCOVER_SPECIFIC_TILE,
				coordination: { x: 553, y: 560 },
				amount: 1,
			},
			reward: {
				type: QuestRewardTypes.GET_BUILDING_TO_STOCK,
				content: [
					{
						reward_resource: FrameName.INDUSTRIAL_LUMBER_MILL,
						amount: 2,
					},
				],
			},
			badgeCoordinates: { x: 553, y: 560 },
		},
	],
	// Questline: Echoes of Pestilence
	[
		5006,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5006",
			flavor: "",
			assignment: "task.explore_location",
			objective: {
				action: QuestObjectiveActions.DISCOVER_SPECIFIC_TILE,
				coordination: { x: 501, y: 528 },
				amount: 1,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 50,
					},
				],
			},
			badgeCoordinates: { x: 501, y: 528 },
		},
	],
	[
		5007,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5007",
			flavor: "",
			assignment: "task.clear_plague",
			objective: {
				action: QuestObjectiveActions.CLEAR_PLAGUE,
				coordination: { x: 501, y: 528 },
				range: 2,
				amount: 24, // (2*range + 1)^2 - 1
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 100,
					},
				],
			},
			badgeCoordinates: { x: 501, y: 528 },
		},
	],
	[
		5008,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5008",
			flavor: "",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 59,
				amount: 12,
			},
			reward: {
				type: QuestRewardTypes.GET_BUILDING_TO_STOCK,
				content: [
					{
						reward_resource: FrameName.LARGE_STONE_QUARRY,
						amount: 1,
					},
				],
			},
			badgeCoordinates: { x: 501, y: 528 },
		},
	],
	[
		5009,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5009",
			flavor: "",
			assignment: "task.explore_location",
			objective: {
				action: QuestObjectiveActions.DISCOVER_SPECIFIC_TILE,
				coordination: { x: 544, y: 505 },
				amount: 1,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.AD_SKIPPER,
						amount: 3,
					},
				],
			},
			badgeCoordinates: { x: 544, y: 505 },
		},
	],
	[
		5010,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5010",
			flavor: "",
			assignment: "task.clear_plague",
			objective: {
				action: QuestObjectiveActions.CLEAR_PLAGUE,
				coordination: { x: 544, y: 505 },
				range: 3,
				amount: 48, // (2*range + 1)^2 - 1
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 150,
					},
				],
			},
			badgeCoordinates: { x: 544, y: 505 },
		},
	],
	[
		5011,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5011",
			flavor: "",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 74,
				amount: 15,
			},
			reward: {
				type: QuestRewardTypes.GET_BUILDING_TO_STOCK,
				content: [
					{
						reward_resource: FrameName.SILVER_MINE,
						amount: 1,
					},
				],
			},
			badgeCoordinates: { x: 544, y: 505 },
		},
	],
	// Questline: A Nice Day for Fishing
	[
		5012,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5012",
			flavor: "",
			assignment: "task.build_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: tilerepoShipyardFrameNames,
				amount: 10,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 250_000,
					},
				],
			},
		},
	],
	[
		5013,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5013",
			flavor: "",
			assignment: "task.build_fishing_boats",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: tilerepoAllFishingBoatsFrameNames,
				amount: 10,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 500_000,
					},
				],
			},
		},
	],
	[
		5014,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5014",
			flavor: "",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 22,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.AD_SKIPPER,
						amount: 3,
					},
				],
			},
		},
	],
	[
		5015,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5015",
			flavor: "",
			assignment: "task.build_fish_traps",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: tilerepoFishTrapsFrameNames,
				amount: 10,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 1_000_000,
					},
				],
			},
		},
	],
	[
		5016,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5016",
			flavor: "",
			assignment: "task.explore_location",
			objective: {
				action: QuestObjectiveActions.DISCOVER_SPECIFIC_TILE,
				coordination: { x: 456, y: 535 },
				amount: 1,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 350,
					},
				],
			},
			badgeCoordinates: { x: 456, y: 535 },
		},
	],
	// Questline: Iron Mines
	[
		5017,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5017",
			flavor: "",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 20,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 75,
					},
				],
			},
		},
	],
	[
		5018,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5018",
			flavor: "",
			assignment: "task.build_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: FrameName.FURNACE,
				amount: 10,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 10_000_000,
					},
				],
			},
		},
	],
	[
		5019,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5019",
			flavor: "",
			assignment: "task.have_iron_income",
			objective: {
				action: QuestObjectiveActions.HAVE_RESOURCE,
				type: ResourceType.IRON_UNCAPPED_INCOME,
				amount: 1000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.AD_SKIPPER,
						amount: 5,
					},
				],
			},
		},
	],
	[
		5020,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5020",
			flavor: "",
			assignment: "task.pay",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.IRON,
				amount: 50_000,
				pay: 0,
			},
			reward: {
				type: QuestRewardTypes.GET_BUILDING_TO_STOCK,
				content: [
					{
						reward_resource: FrameName.UNIVERSAL_WAREHOUSE,
						amount: 3,
					},
				],
			},
		},
	],
	// Questline: Goods for the Good Men
	[
		5021,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5021",
			flavor: "",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 25,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 100,
					},
				],
			},
		},
	],
	[
		5022,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5022",
			flavor: "",
			assignment: "task.have_blacksmiths",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: tileRepoBlacksmithFrameNames,
				amount: 15,
			},
			reward: {
				type: QuestRewardTypes.GET_BUILDING_TO_STOCK,
				content: [
					{
						reward_resource: FrameName.SILVER_MINE,
						amount: 1,
					},
				],
			},
		},
	],
	[
		5023,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5023",
			flavor: "",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 30,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.AD_SKIPPER,
						amount: 5,
					},
				],
			},
		},
	],
	[
		5024,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5024",
			flavor: "",
			assignment: "task.have_buildings",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: new Set([FrameName.TAILORS_WORKSHOP]),
				amount: 10,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 10_000_000,
					},
				],
			},
		},
	],
	[
		5025,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5025",
			flavor: "",
			assignment: "task.upgrade_town_to_level",
			objective: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 36,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 150,
					},
				],
			},
		},
	],
	[
		5026,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5026",
			flavor: "",
			assignment: "task.have_buildings",
			objective: {
				action: QuestObjectiveActions.HAVE_TERRAIN,
				type: new Set([FrameName.TOOLMAKER]),
				amount: 15,
			},
			reward: {
				type: QuestRewardTypes.GET_BUILDING_TO_STOCK,
				content: [
					{
						reward_resource: FrameName.UNIVERSAL_WAREHOUSE,
						amount: 3,
					},
				],
			},
		},
	],
	[
		5027,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5027",
			flavor: "",
			assignment: "task.have_storage_capacity",
			objective: {
				action: QuestObjectiveActions.HAVE_STORAGE,
				type: ResourceType.GOODS,
				amount: 175_000,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 40_000_000,
					},
				],
			},
		},
	],
	[
		5028,
		{
			type: QuestTypes.SIDE,
			title: "quest.name_5028",
			flavor: "",
			assignment: "task.pay",
			objective: {
				action: QuestObjectiveActions.USE_RESOURCES,
				type: ResourceType.GOODS,
				amount: 175_000,
				pay: 0,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE_INCOME,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: 1_000,
					},
				],
			},
		},
	],

	// ################ Daily quests ####################
	[
		9001,
		{
			type: QuestTypes.DAILY,
			title: "quest.name_1001",
			flavor: "",
			assignment: "task.complete_daily_quests",
			objective: {
				action: QuestObjectiveActions.COMPLETE_DAILY_QUESTS,
				amount: 3,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.GEMS,
						amount: 15,
					},
				],
			},
		},
	],
	[
		9002,
		{
			type: QuestTypes.DAILY,
			title: "quest.name_1001",
			flavor: "",
			assignment: "task.explore_tiles",
			objective: {
				action: QuestObjectiveActions.CLEAR_TILES,
				amount: 15,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 5,
					},
				],
			},
		},
	],
	[
		9003,
		{
			type: QuestTypes.DAILY,
			title: "quest.name_1001",
			flavor: "",
			assignment: "task.build_any_buildings",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: tilerepoBuildingsFrameNames,
				amount: 5,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: (): number => {
							return useResourcesStore().coinsIncome * 5;
						},
					},
				],
			},
		},
	],
	[
		9004,
		{
			type: QuestTypes.DAILY,
			title: "quest.name_1001",
			flavor: "",
			assignment: "task.build_roads",
			objective: {
				action: QuestObjectiveActions.BUILD_BUILDING,
				type: tilerepoRoadsFrameNames,
				amount: 20,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: (): number => {
							return useResourcesStore().coinsIncome * 5;
						},
					},
				],
			},
		},
	],
	[
		9005,
		{
			type: QuestTypes.DAILY,
			title: "quest.name_1001",
			flavor: "",
			assignment: "task.click_settlements",
			objective: {
				action: QuestObjectiveActions.CLICK_ON_SETTLEMENT,
				amount: 50,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.SUPER_CLICKER,
						amount: 5,
					},
				],
			},
		},
	],
	[
		9006,
		{
			type: QuestTypes.DAILY,
			title: "quest.name_1001",
			flavor: "",
			assignment: "task.watch_2to4_ads",
			objective: {
				action: QuestObjectiveActions.WATCH_ADS,
				amount: 3,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.COINS,
						amount: (): number => {
							return useResourcesStore().coinsIncome * 5;
						},
					},
				],
			},
		},
	],
	[
		9007,
		{
			type: QuestTypes.DAILY,
			title: "quest.name_1001",
			flavor: "",
			assignment: "task.spend_coins",
			objective: {
				action: QuestObjectiveActions.SPEND_RESOURCES,
				type: ResourceType.COINS,
				amount: (): number => {
					return useResourcesStore().coinsIncome * 60;
				},
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.AD_SKIPPER,
						amount: 1,
					},
				],
			},
		},
	],

	// ############## PIGGY BANK ###################
	[
		PIGGY_BANK_QUEST_ID,
		{
			type: QuestTypes.OFFER,
			title: "quest.name_10001",
			flavor: "quest.flavor_10001",
			assignment: "task.buy_offer_10001",
			objective: {
				action: QuestObjectiveActions.PIGGY_BANK_PROGRESS,
				amount: PIGGY_BANK_MAX_PROGRESS,
			},
			reward: {
				type: QuestRewardTypes.RESOURCE,
				content: [
					{
						reward_resource: ResourceType.GEMS,
						amount: 50,
					},
				],
			},
		},
	],
]);
